exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.theme--light.v-expansion-panel .v-expansion-panel__container[data-v-4c0cd1d1] {\r\n  background-color: yellow;\n}\r\n", ""]);

